import { registerFunctionalComponent } from 'js/lib/components/component'
import { useFormInput } from 'js/lib/form'

registerFunctionalComponent('.js-c-form-input--text', 'InputText', InputText)

function InputText(component) {
  const { onDependentChange } = useFormInput(component.element)
  onDependentChange(dependency => handleDependentChange(component.element, dependency))
}

function handleDependentChange(input, dependency) {
  switch (dependency.behaviour.type) {
    case 'value':
      updateValue(input, dependency.behaviour.getValue())
      break
  }
}

function updateValue(input, value) {
  input.value = String(value)
  input.dispatchEvent(new window.Event('change', { bubbles: true, cancelable: true }))
}
